import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import API from 'utils/api';
import { onError } from 'utils/handlers';
import { selectEstadosGlobales } from 'store/catalogos';

const baseURI = '/catalogos/categorias-de-iconografia/';

export const permissionCategoriaDeIconografia = {
  permissionModel: 'categoriadeiconografia',
};

// eslint-disable-next-line react/prop-types
function CategoriaDeIconografia({ permission }) {
  const estadosGlobales = useSelector(selectEstadosGlobales);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await API.get(baseURI);
      setData(res.data);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    fetchData();
    return () => API.tryCancel;
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 250,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          loading={loading}
          mobileColIndex={0}
          permission={permission}
        />
      </Spin>
    </Row>
  );
}

export default CategoriaDeIconografia;
